import { Component, inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { OauthService } from 'src/app/services/oauth.service';
import { MatButton } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton],
})
export class LoginComponent implements OnInit {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  private auth = inject(AuthService);
  private oauth = inject(OauthService);
  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);
  private snack = inject(MatSnackBar);

  redirect: string | null = null;
  session_expired = false;
  starting = false;

  ngOnInit(): void {
    const query_redirect = this.activatedRoute.snapshot.queryParamMap.get('redirect');
    this.session_expired = this.activatedRoute.snapshot.queryParamMap.get('expired') === '1';

    if (query_redirect) {
      this.oauth.rememberPostLoginRedirect(query_redirect);
      this.redirect = query_redirect;
    } else {
      this.redirect = this.oauth.peekPostLoginRedirect();
    }

    if (this.session_expired) {
      this.snack.open('Tu sesión ha caducado. Vuelve a iniciar sesión.', 'Ok', { duration: 4000 });
    }
  }

  startLogin(): void {
    this.starting = true;
    this.auth.startOauthLogin(this.redirect);
  }
}
